
if (import.meta.hot) {
  import.meta.hot.accept((mod) => {
    const router = import.meta.hot.data.router
    const generateRoutes = import.meta.hot.data.generateRoutes
    if (!router || !generateRoutes) {
      import.meta.hot.invalidate('[nuxt] Cannot replace routes because there is no active router. Reloading.')
      return
    }
    router.clearRoutes()
    const routes = generateRoutes(mod.default || mod)
    function addRoutes (routes) {
      for (const route of routes) {
        router.addRoute(route)
      }
      router.replace(router.currentRoute.value.fullPath)
    }
    if (routes && 'then' in routes) {
      routes.then(addRoutes)
    } else {
      addRoutes(routes)
    }
  })
}

export function handleHotUpdate(_router, _generateRoutes) {
  if (import.meta.hot) {
    import.meta.hot.data ||= {}
    import.meta.hot.data.router = _router
    import.meta.hot.data.generateRoutes = _generateRoutes
  }
}
import { default as gmmhGlBSjO98Xje9L6DtoVn6OoJv1wzCzspLN6CMLKxsMeta } from "/codebuild/output/src2541824666/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/g.vue?macro=true";
import { default as indexHB1BXzGysKTttAl4SPNpHcAngzzvEouK33ChbLAS04IMeta } from "/codebuild/output/src2541824666/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/index.vue?macro=true";
import { default as searchoNktYHae2ZPJEm_45I9z8xVrSxszQVqapMYaVRabxbywYMeta } from "/codebuild/output/src2541824666/src/actions-runner/_work/onenews/onenews/web-services/common/pages/search.vue?macro=true";
import { default as index5B1iZAhKgu_45xc8FUim760CmBLBPzRE9dzubKJ1_45xEsgMeta } from "/codebuild/output/src2541824666/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/v8/index.vue?macro=true";
import { default as _91id_93bEUawYSemaPQTYg14UNYNt_45dJpY7TLFzMCrxtUsehSQMeta } from "/codebuild/output/src2541824666/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/video/[id].vue?macro=true";
import { default as indexUm5fb4OUIUznUVu6hvdZbUZAlZcYEtaG9ef1QTIC7_4Meta } from "/codebuild/output/src2541824666/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/terms/index.vue?macro=true";
import { default as _91id_93YDqmV8HV1HozAOVWit6YHyagHISkgdzfJbaYGcf_45i3sMeta } from "/codebuild/output/src2541824666/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/article/[id].vue?macro=true";
import { default as index22hccZEt8uydOHqTFFT_HZcgXfjfsi1KrtJS7j6tqVkMeta } from "/codebuild/output/src2541824666/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/contact/index.vue?macro=true";
import { default as _91id_93L8_qHxqM0YM3V8e6EOIWEs69SRJa6KW7ku5mrtYIgPoMeta } from "/codebuild/output/src2541824666/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/v8/article/[id].vue?macro=true";
import { default as indexLFuYIN2CZjo_45XvGwRLVIqV7RhSQF7LEu9f7cQJD6upYMeta } from "/codebuild/output/src2541824666/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/privacy-policy/index.vue?macro=true";
import { default as indexts9QZzbTkpbzbz_gs8mV4CvKlmTrksZo91NFWWtgXjIMeta } from "/codebuild/output/src2541824666/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/privacy-policy/relationships/index.vue?macro=true";
export default [
  {
    name: "g",
    path: "/g",
    component: () => import("/codebuild/output/src2541824666/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/g.vue")
  },
  {
    name: "index",
    path: "/",
    component: () => import("/codebuild/output/src2541824666/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/index.vue")
  },
  {
    name: "search",
    path: "/search",
    component: () => import("/codebuild/output/src2541824666/src/actions-runner/_work/onenews/onenews/web-services/common/pages/search.vue")
  },
  {
    name: "v8",
    path: "/v8",
    component: () => import("/codebuild/output/src2541824666/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/v8/index.vue")
  },
  {
    name: "video-id",
    path: "/video/:id()",
    component: () => import("/codebuild/output/src2541824666/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/video/[id].vue")
  },
  {
    name: "terms",
    path: "/terms",
    meta: indexUm5fb4OUIUznUVu6hvdZbUZAlZcYEtaG9ef1QTIC7_4Meta || {},
    component: () => import("/codebuild/output/src2541824666/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/terms/index.vue")
  },
  {
    name: "article-id",
    path: "/article/:id()",
    component: () => import("/codebuild/output/src2541824666/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/article/[id].vue")
  },
  {
    name: "contact",
    path: "/contact",
    meta: index22hccZEt8uydOHqTFFT_HZcgXfjfsi1KrtJS7j6tqVkMeta || {},
    component: () => import("/codebuild/output/src2541824666/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/contact/index.vue")
  },
  {
    name: "v8-article-id",
    path: "/v8/article/:id()",
    component: () => import("/codebuild/output/src2541824666/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/v8/article/[id].vue")
  },
  {
    name: "privacy-policy",
    path: "/privacy-policy",
    meta: indexLFuYIN2CZjo_45XvGwRLVIqV7RhSQF7LEu9f7cQJD6upYMeta || {},
    component: () => import("/codebuild/output/src2541824666/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/privacy-policy/index.vue")
  },
  {
    name: "privacy-policy-relationships",
    path: "/privacy-policy/relationships",
    meta: indexts9QZzbTkpbzbz_gs8mV4CvKlmTrksZo91NFWWtgXjIMeta || {},
    component: () => import("/codebuild/output/src2541824666/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/privacy-policy/relationships/index.vue")
  }
]